/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NB_AUTH_OPTIONS } from '@nebular/auth/auth.options';
import { getDeepFromObject } from '@nebular/auth/helpers';
import { TranslateService } from '@ngx-translate/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { NbAuthResult, NbTokenService, NbAuthJWTToken } from '@nebular/auth';
import { NbAuthService } from '@nebular/auth/services/auth.service';
import { ActionService } from '../../../../@core/data/action.service';
import { ActivatedRoute } from '@angular/router';
import { Console } from 'console';

@Component({
  selector: 'ngx-login',
  styleUrls: ['./login.component.scss'],
  templateUrl: './login.component.html',
})
export class NgxLoginComponent implements OnInit {
  redirectDelay = 0;
  showMessages: any = {};
  provider = '';
  currentLang = 'es';

  errors: string[] = [];
  messages: string[] = [];
  user: any = {};
  submitted = false;
  logo = '';

  clvServicio: string | null = null;
  sessionState: string | null = null;
  code: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private tokenService: NbTokenService,
    private http: HttpClient,
    protected router: Router,
    private actionService: ActionService,
    protected service: NbAuthService,
    protected translate: TranslateService,
    @Inject(NB_AUTH_OPTIONS) protected config = {},
  ) {
    try {
      this.redirectDelay = this.getConfigValue('forms.login.redirectDelay');
      this.showMessages = this.getConfigValue('forms.login.showMessages');
      this.provider = this.getConfigValue('forms.login.provider');
      this.translate.onLangChange.subscribe((event: any) => {
        this.currentLang = event.lang;
      });
      const headers: HttpHeaders = new HttpHeaders({
        'Content-Type': 'application/json',
      });
      const options = {headers: headers};
      this.http
        .get('https://server.sinecta.com/api/v1/domains', options)
        .subscribe(
          (result: any) => {
            const full = window.location.host;
            // const full = 'clientes.sinecta.com';
            if(full) {
              const parts = full.split('.');
              const sub = parts[0];
              let domain = `${parts[0]}.${parts[1]}`;
              if (domain === 'app.sinecta') { // app.sinecta.com
                return this.logo = '/assets/images/aura_gds_white.png';
              }
  
              // if (domain === 'clientes.sinecta' || sub == 'localhost:4200') { // app.sinecta.com
              //   return this.logo = 'https://server.sinecta.com/assets/images/domains/sinecta_white.png';
              // }
  
              if (domain === 'clientes.sinecta' || sub == 'localhost:4200') { // app.sinecta.com
                return this.logo = '/assets/images/clientes/Sinecta_Logotipo-2-03.png';
                // return this.logo = 'https://server.sinecta.com/assets/images/clientes/Sinecta_Logotipo-2-03.png';
              }
    
              const domains = result.find(d => d['name'] === sub);
              if (domains) {
                if (sub.includes('sinecta') || sub == ('localhost:4200')) { // sinecta.ana-ia.com
                  return this.logo = 'https://server.sinecta.com/assets/images/domains/sinecta_white.png';
                } else {
                  return this.logo = `https://server.sinecta.com/assets/images/domains/${domains['image']}`;
                }
              } else {
                return this.logo = 'https://server.sinecta.com/assets/images/domains/clientes.png';
              }
            } else {
              return this.logo = 'https://server.sinecta.com/assets/images/domains/aura_gds_white.png';
            }
          });
    } catch (error) {
      console.log(error);
    }
  }

  ngOnInit(): void {
    localStorage.clear();
    sessionStorage.clear();
    this.changeLanguage('es');

    this.route.queryParams.subscribe(params => {
      this.clvServicio = params['clv_servicio'];
      this.sessionState = params['session_state'];
      this.code = params['code'];

      if(params['code']){
        this.sendRequest();
      }
      if(params['token_ops']){

        let url = 'https://server.sinecta.com';
        if(window.location.pathname === '/exp/' || window.location.host === 'localhost:4200') {
          url = 'https://staging.sinecta.com';
        }

        let requestData = {
          url: url + "/api/v1/users/authops?token=" + params['token_ops'],
          headers: { "Content-Type": "application/x-www-form-urlencoded" }
        };

        const headers = new HttpHeaders(requestData.headers);

        this.http.post(requestData.url, {}, { headers, responseType: 'text' as 'json' })
          .subscribe(
            (response: string) => {
              this.LoginToken(response);
            },
            error => console.error('Error:', error)
          );
        }

    });
    
    // this.LoginToken();
  }

  sendRequest(): void {

    let requestData = {
      url: "https://staging.sinecta.com/api/v1/agritech_fira/getAuth",
      body: {
        tokencode: this.code,
      },
      headers: { "Content-Type": "application/x-www-form-urlencoded" }
    };

    const headers = new HttpHeaders(requestData.headers);
    const body = new URLSearchParams(requestData.body as any).toString();

    this.http.post(requestData.url, body, { headers })
      .subscribe(
        (response:any):any => {
          this.LoginToken(response.token);
        },
        error => console.error('Error:', error)
      );
  }

  Redirect(){
    window.location.href =
      'https://desagritech.fira.gob.mx/sec/realms/agritech-qa/protocol/openid-connect/auth?client_id=agritech_sinecta&response_type=code&scope=openid&redirect_uri=https://operaciones.sinecta.com/exp/auth-monitoreo?clv_servicio=S01';
  }

  LoginToken(token:any){
    // localStorage.setItem('auth_app_token', token);

    console.log(token);

    this.tokenService.set(new NbAuthJWTToken(token));

    const { hostname, pathname } = window.location;

    setTimeout(() => {
      if (hostname === "localhost" || (hostname === "clientes.sinecta.com" && pathname === "/exp/")) {
        window.location.href = '/exp/#/user/dashboard';
      } else{
        window.location.href = '/#/user/dashboard';
      }
    }, 800);

    // try {
    //   setTimeout(() => {
    //     return this.router.navigateByUrl('/user/dashboard');
    //   }, this.redirectDelay);
    // } catch (e) {
    //   console.log(e);
    // }
  }

  changeLanguage(lang: string): void {
    this.translate.use(lang);
  }

  login(): void {
    try {
      this.errors = this.messages = [];
      this.submitted = true;
      
      this.service
      .authenticate(this.provider, this.user)
      .subscribe((result: NbAuthResult) => {
        this.submitted = false;
        
        if (result.isSuccess()) {
          sessionStorage.clear();
          this.actionService.createAction({action: 'login'})
          this.messages = result.getMessages();
        } else {
          this.errors = result.getErrors();
        }
        
        const redirect = result.getRedirect();
        try {
          if (redirect) {
            setTimeout(() => {
                return this.router.navigateByUrl(redirect);
              }, this.redirectDelay);
            }
          } catch (e) {
            console.log(e);
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  getConfigValue(key: string): any {
    return getDeepFromObject(this.config, key, null);
  }
}
